/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
import type { calendarSpaceCalendar_calendar$ref } from "./calendarSpaceCalendar_calendar.graphql";
export type lazyContentDataQueryVariables = {|
  spaceRef: string
|};
export type lazyContentDataQueryResponse = {|
  +item: ?{|
    +calendar: ?$ReadOnlyArray<?{|
      +$fragmentRefs: calendarSpaceCalendar_calendar$ref
    |}>,
    +diary: ?$ReadOnlyArray<?{|
      +dateKey: ?string,
      +category: ?string,
      +riders: ?number,
      +period: ?number,
    |}>,
  |}
|};
export type lazyContentDataQuery = {|
  variables: lazyContentDataQueryVariables,
  response: lazyContentDataQueryResponse,
|};
*/


/*
query lazyContentDataQuery(
  $spaceRef: String!
) {
  item: getSpaceByRef(ref: $spaceRef) {
    calendar {
      ...calendarSpaceCalendar_calendar
    }
    diary {
      dateKey
      category
      riders
      period
    }
    id
  }
}

fragment calendarSpaceCalendar_calendar on CalendarByDay {
  day
  checkin
  checkout
  checkinMorning
  checkoutMorning
  checkinAfternoon
  checkoutAfternoon
  checkinNight
  checkoutNight
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "spaceRef"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "ref",
    "variableName": "spaceRef"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "concreteType": "BookingDiary",
  "kind": "LinkedField",
  "name": "diary",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "dateKey",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "category",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "riders",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "period",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "lazyContentDataQuery",
    "selections": [
      {
        "alias": "item",
        "args": (v1/*: any*/),
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "getSpaceByRef",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "CalendarByDay",
            "kind": "LinkedField",
            "name": "calendar",
            "plural": true,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "calendarSpaceCalendar_calendar"
              }
            ],
            "storageKey": null
          },
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "lazyContentDataQuery",
    "selections": [
      {
        "alias": "item",
        "args": (v1/*: any*/),
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "getSpaceByRef",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "CalendarByDay",
            "kind": "LinkedField",
            "name": "calendar",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "day",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "checkin",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "checkout",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "checkinMorning",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "checkoutMorning",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "checkinAfternoon",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "checkoutAfternoon",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "checkinNight",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "checkoutNight",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "ab5a90b3f1a0d0c5c91c961208f8cd47",
    "id": null,
    "metadata": {},
    "name": "lazyContentDataQuery",
    "operationKind": "query",
    "text": "query lazyContentDataQuery(\n  $spaceRef: String!\n) {\n  item: getSpaceByRef(ref: $spaceRef) {\n    calendar {\n      ...calendarSpaceCalendar_calendar\n    }\n    diary {\n      dateKey\n      category\n      riders\n      period\n    }\n    id\n  }\n}\n\nfragment calendarSpaceCalendar_calendar on CalendarByDay {\n  day\n  checkin\n  checkout\n  checkinMorning\n  checkoutMorning\n  checkinAfternoon\n  checkoutAfternoon\n  checkinNight\n  checkoutNight\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '9ba058fae539e43145250f22391eb7f6';

module.exports = node;
